import { render } from "./DefaultView.vue?vue&type=template&id=2686f9ee"
import script from "./DefaultView.vue?vue&type=script&lang=js"
export * from "./DefaultView.vue?vue&type=script&lang=js"

import exportComponent from "F:\\PWAs\\mode-pwa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__